import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 14px;
  height: 13px;
  color: #4a90e2;
`

const Copy = ({ title = 'Copy', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 14 13" title={title} {...rest}>
    <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="square">
      <path d="M8.575 5.884v4.127M10.638 7.947H6.512M4.154 3.526h8.842v8.842H4.154z" />
      <path d="M2.893 9.842H.996V1h8.842v1.263" />
    </g>
  </StyledIcon>
)

Copy.displayName = 'Copy'
Copy.needsWork = true
export default Copy
